<template>
    <BaseLink
        v-if="!isAppEnv"
        :class="[$style.button_override, !!user && $style.mobile_auth_override]"
        data-interface-target="playgama-ai-header-button"
        :externalTo="PLAYGAMA_AI_URL"
        target="_blank"
    >
        <img
            :class="$style.icon"
            :src="PlaygamaAiImg"
            alt="Playgama AI"
        />
        <Typography
            type="caption"
            size="all-caps"
            semibold
            :class="$style.label"
        >
            {{ $tr('header.createAndPlay') }}
        </Typography>
    </BaseLink>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import BaseLink from '@/components/BaseLink.vue'
import Typography from '@/components/Typography.vue'
import { PLAYGAMA_AI_URL } from '@/constants/general'
import { useAppStore } from '@/store/app-store'
import { useUserStore } from '@/store/user-store/user-store'

import PlaygamaAiImg from './images/playgama-ai.svg?url'

const { user } = storeToRefs(useUserStore())
const { isAppEnv } = storeToRefs(useAppStore())
</script>

<style module>
.button_override {
    flex-shrink: 0;
    box-sizing: border-box;
    display: none;
    align-items: center;
    gap: 8px;
    height: 48px;
    padding: 8px;
    border-radius: 2px;
    background: var(--carbon-400);
}

/* Visible at 382px+ regardless of auth state */
@media (min-width: 382px) {
    .button_override {
        display: flex;
    }
}

/* Visible at 360px+ for authenticated users */
@media (min-width: 360px) {
    .mobile_auth_override {
        display: flex;
    }
}

.icon {
    width: 32px;
    height: 32px;
}

.label {
    display: none;
    width: min-content;
    font-size: 11px;
    line-height: 1.06;
    letter-spacing: 0.33px;
    color: var(--lavander-600);
}

@media (--desktop-small-plus) {
    .button_override {
        height: 52px;
        transition: box-shadow 0.3s;
    }

    .button_override:hover,
    .button_override:focus {
        box-shadow: 0 0 30px 0 rgba(163, 109, 253, 0.64) inset;
        outline: 0.5px solid var(--purple-300);
    }
}

/* The label only fits once the header tiles stop shrinking */
@media (--desktop-large-plus) {
    .button_override {
        padding: 4px 16px 4px 8px;
    }

    .label {
        display: block;
    }
}
</style>
